export interface NavItem {
    displayName: string;
    path: string;
    relativePath: string;
    wildcardPath: string;
}

export const NavItems = {
    Main: {
        Root: {
            displayName: "Main",
            path: "/",
            relativePath: "/",
            wildcardPath: "/*"
        } as NavItem
    },
    NotAccess: {
        Landing: {
            displayName: "Landing",
            path: "/notAccess",
            wildcardPath: "/notAccess/*"
        } as NavItem
    },
    Admin: {
        Landing: {
            displayName: "Landing",
            path: "/admin",
            wildcardPath: "/admin/*"
        },
        Assessments: {
            parentRoot: "/admin/assessments/",
            Upcoming: {
                displayName: "Upcoming Assessments",
                path: "/admin/assessments/assessmentsUpcoming",
                relativePath: "/assessmentsUpcoming",
                wildcardPath: "/admin/assessments/*"
            } as NavItem,
            Completed: {
                displayName: "Completed Assessments",
                path: "/admin/assessments/assessmentsCompleted",
                relativePath: "/assessmentsCompleted"
            } as NavItem,
            Remote: {
                displayName: "Remote Assessments",
                path: "/admin/assessments/remoteAssessments",
                relativePath: "/remoteAssessments"
            } as NavItem
        },
        Results: {
            parentRoot: {
                displayName: "Results",
                path: "/admin/results/",
                relativePath: "/",
                wildcardPath: "/admin/results/*"
            } as NavItem,
            Details: {
                displayName: "Assessment Details",
                path: "/admin/results/details/",
                relativePath: "/details/"
            } as NavItem,
            Archived: {
                displayName: "Archived",
                path: "/admin/results/archived/",
                relativePath: "/archived/"
            } as NavItem
        },
        Manage: {
            parentRoot: "/admin/manage",
            Overview: {
                displayName: "Overview",
                path: "/admin/manage/overview",
                wildcardPath: "/admin/manage/*"
            } as NavItem,
            Staff: {
                displayName: "Staff",
                path: "/admin/manage/staff",
                relativePath: "/staff"
            } as NavItem,
            Examinees: {
                displayName: "Examinees",
                path: "/admin/manage/examinees",
                relativePath: "/examinees"
            } as NavItem,
            RolesAndPermissions: {
                displayName: "Roles & Permissions",
                path: "/admin/manage/rolesAndPermissions",
                relativePath: "/rolesAndPermissions"
            } as NavItem,
            LocationDetails: {
                displayName: "Location Details",
                path: "/admin/manage/locations",
                relativePath: "/locations"
            }
        }
    },
    Documentation: {
        Landing: {
            displayName: "Landing",
            path: "/documentations",
            wildcardPath: "/documentations/*"
        } as NavItem,
        SupportTraning: {
            displayName: "Support and training",
            path: "/documentations",
            relativePath: "/documentations"
        } as NavItem
    },
    SuperAdmin: {
        Landing: {
            displayName: "Landing",
            path: "/superadmin",
            wildcardPath: "/superadmin/*"
        } as NavItem,
        Organizations: {
            displayName: "Organizations",
            path: "/superadmin/organizations",
            relativePath: "/organizations"
        } as NavItem,
        OrganizationDetails: {
            displayName: "Organization Details",
            path: "/superadmin/organizations/",
            relativePath: "/organizations/"
        },
        CreateOrganization: {
            displayName: "Create Organization",
            path: "/superadmin/createOrganization",
            relativePath: "/createOrganization"
        } as NavItem,
        WordSuggestions: {
            displayName: "Word Suggestions",
            path: "/superadmin/wordSuggestions",
            relativePath: "/wordSuggestions"
        }
    },
    Assessments: {
        Landing: {
            displayName: "Assessments",
            path: "/assessments/welcome",
            relativePath: "/welcome",
            wildcardPath: "/assessments/*"
        } as NavItem,
        RemoteLanding: {
            displayName: "Remote Assessment",
            path: "/assessments/remote/",
            relativePath: "/remote/:token",
            wildcardPath: "/assessments/remote/:token"
        } as NavItem,
        PracticeInstruction: {
            displayName: "Assessments Practice Instruction",
            path: "/assessments/practiceInstruction",
            relativePath: "/practiceInstruction"
        } as NavItem,
        PracticeBeginRun: {
            displayName: "Assessments Practice Instruction",
            path: "/assessments/practiceBeginRun",
            relativePath: "/practiceBeginRun"
        } as NavItem,
        DeviceCheckInstruction: {
            displayName: "Assessment Device Check Instruction",
            path: "/assessments/deviceCheckInstruction",
            relativePath: "/deviceCheckInstruction"
        } as NavItem,
        PracticeTestRun: {
            displayName: "Assessments Practice Instruction",
            path: "/assessments/practiceTestRun",
            relativePath: "/practiceTestRun"
        } as NavItem,
        Begin: {
            displayName: "Assessment Begin",
            path: "/assessments/begin",
            relativePath: "/begin"
        },
        Start: {
            displayName: "Assessment Start",
            path: "/assessments/start",
            relativePath: "/start"
        },
        Instruction: {
            displayName: "List Present Targets",
            path: "/assessments/instruction",
            relativePath: "/instruction"
        },
        InstructionCountdown: {
            displayName: "Free recalls 1 ab",
            path: "/assessments/instructionCountdown",
            relativePath: "/instructionCountdown"
        },
        AssessmentPresentTargets: {
            displayName: "Assessments PresentTargets",
            path: "/assessments/assessmentPresentTargets",
            relativePath: "/assessmentPresentTargets"
        } as NavItem,
        AssessmentFreeRecall: {
            displayName: "Assessment Free Recall",
            path: "/assessments/assessmentFreeRecall",
            relativePath: "/assessmentFreeRecall"
        } as NavItem,
        AssessmentCuedRecalls: {
            displayName: "Assessment Cued Recalls",
            path: "/assessments/assessmentCuedRecalls",
            relativePath: "/assessmentCuedRecalls"
        },
        AssessmentComplete: {
            displayName: "Assessment Complete",
            path: "/assessments/assessmentComplete",
            relativePath: "/assessmentComplete"
        } as NavItem,
        AssessmentClosingVideo: {
            displayName: "Assessment Closing Video",
            path: "/assessments/assessmentClosingVideo",
            relativePath: "/assessmentClosingVideo"
        } as NavItem,
        AssessmentDelayedRecall: {
            displayName: "Assessment Delayed Recall",
            path: "/assessments/assessmentDelayedRecall",
            relativePath: "/assessmentDelayedRecall"
        },
        AssessmentReview: {
            displayName: "Assessment Review",
            path: "/assessments/assessmentReview",
            relativePath: "/assessmentReview"
        } as NavItem,
        AssessmentChecks: {
            displayName: "Assessment Checks",
            path: "/assessments/assessmentChecks",
            relativePath: "/assessmentChecks"
        } as NavItem,
        ContactFacilitator: {
            displayName: "Assessment Contact Facilitator",
            path: "/assessments/contactFacilitator",
            relativePath: "/contactFacilitator"
        } as NavItem
    },
    Signup: {
        Landing: {
            displayName: "Signup",
            path: "/signup",
            wildcardPath: "/signup/*"
        } as NavItem,
        UserCreated: {
            displayName: "User created",
            path: "/signup/userCreated",
            relativePath: "/userCreated"
        } as NavItem,
        OrgInfo: {
            displayName: "Organization Info",
            path: "/signup/orginfo",
            relativePath: "/orginfo"
        } as NavItem,
        Terms: {
            displayName: "Review Terms and Conditions",
            path: "/signup/terms",
            relativePath: "/terms"
        } as NavItem,
        ContactSales: {
            displayName: "Contact Sales",
            path: "/signup/contactSales",
            relativePath: "/contactSales"
        } as NavItem,
        ContactConfirm: {
            displayName: "Contact Confirm",
            path: "/signup/contactConfirm",
            relativePath: "/contactConfirm"
        } as NavItem,
        SetupAccount: {
            displayName: "Setup Account",
            path: "/signup/setupAccount",
            relativePath: "/setupAccount"
        } as NavItem
    },
    Login: {
        Landing: {
            displayName: "Login",
            path: "/login",
            wildcardPath: "/login/*"
        } as NavItem
    },
    Purchase: {
        Landing: {
            displayName: "Purchase",
            path: "/purchase",
            wildcardPath: "/purchase/*"
        } as NavItem,
        Pricing: {
            displayName: "Pricing",
            path: "/purchase/pricing",
            relativePath: "/pricing"
        } as NavItem,
        Checkout: {
            displayName: "Checkout",
            path: "/purchase/checkout",
            relativePath: "/checkout"
        } as NavItem,
        SignupCheckout: {
            displayName: "Signup Checkout",
            path: "/purchase/signupcheckout",
            relativePath: "/signupcheckout"
        } as NavItem,
        PurchaseCompleted: {
            displayName: "Purchase Completed",
            path: "/purchase/completed",
            relativePath: "/completed"
        } as NavItem
    }
};
